import React from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_SIZES, BUTTON_TYPES } from 'shared/UI/Button'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { triggerClickOnEnter, ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

const SubmitButton = ({
  onClick,
  submitLabel,
  themeColorHex,
  submitting,
  submitSucceeded,
  successMessage,
  getTranslation
}) => {

  const SUBMIT_CONFIG = {
    initial: {
      className: "",
      label: submitLabel || getTranslation(TRANSLATION_VALUE_KEYS.send).toUpperCase(),
      iconClassName: "",
      onClick: onClick
    },
    submitting: {
      className: "submitting",
      label: getTranslation(TRANSLATION_VALUE_KEYS.sending).toUpperCase(),
      iconClassName: "loader"
    },
    done: {
      className: "submit-done",
      label: successMessage || getTranslation(TRANSLATION_VALUE_KEYS.done).toUpperCase(),
      iconClassName: "icon-tick-sign"
    }
  }

  const config = submitSucceeded ? SUBMIT_CONFIG.done :
    (submitting ? SUBMIT_CONFIG.submitting : SUBMIT_CONFIG.initial)

  return (
    <Button
      customStyle={{backgroundColor: themeColorHex, borderColor: themeColorHex}}
      className={`submit-btn ${config.className} ${ACCESSIBILITY_CLASSES.main}`}
      onClick={config.onClick}
      onKeyDown={triggerClickOnEnter}
      size={BUTTON_SIZES.medium}
      type={BUTTON_TYPES.primary}
      icon={config.iconClassName}
      tabIndex={TAB_INDEXES.SubmitButton}>
      <label className="submit-btn-text">{config.label}</label>
    </Button>
  )
}

SubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  submitLabel: PropTypes.string,
  submitting: PropTypes.bool,
  submitSucceeded: PropTypes.bool,
  successMessage: PropTypes.string
}

SubmitButton.defaultProps = {
  submitting: false
}

export default withTranslation(TRANSLATION_KEYS.submitButton)(SubmitButton)